module.exports = {
  olegGubin: {
    url: '/blog/oleg-gubin/',
    img: '/uploads/resources/experts/oleg-gubin/card.jpg',
    name: 'Oleg Gubin',
    role: 'Founder, COO',
    avatar: '/uploads/resources/experts/oleg-gubin/avatar.jpg',
  },
  pavelSaskovec: {
    url: '/blog/pavel-saskovec/',
    img: '/uploads/resources/experts/pavel-saskovec/card.jpg',
    name: 'Pavel Saskovec',
    role: 'Technical Writer',
    avatar: '/uploads/resources/experts/pavel-saskovec/avatar.jpg',
  },
  kseniyaMeshkova: {
    url: '/blog/kseniya-meshkova/',
    img: '/uploads/resources/experts/kseniya-meshkova/card.jpg',
    name: 'Kseniya Meshkova',
    role: 'Chief Scientific Officer',
    avatar: '/uploads/resources/experts/kseniya-meshkova/avatar.jpg',
  },
  mariaTarnopalskaya: {
    img: '/uploads/next/avatar-female.jpg',
    name: 'Maria Tarnopalskaya',
    role: 'Technical Writer',
  },
  anastasiyaVishnevskaya: {
    img: '/uploads/next/avatar-female.jpg',
    name: 'Anastasiya Vishnevskaya',
    role: 'СМО',
  },
};
